import { Component, Input } from '@angular/core';

@Component({
  selector: 'np-footer',
  standalone: true,
  imports: [],
  templateUrl: 'footer.component.html',
})
export class FooterComponent {
  @Input() contentContactUrl: string = '';
  @Input() contentContactName: string = '';
  @Input() technicalContactUrl: string = '';
  @Input() technicalContactName: string = '';
  @Input() copyright = new Date().getFullYear().toString();
  @Input() confidentiality = 'Company Confidential';
  @Input() opCoName = 'ITC';
  @Input() opCoUrl = 'https://tps.chevron.com/itc/';
}
